import { render, staticRenderFns } from "./ExternalShareAction.vue?vue&type=template&id=2812a40a"
import script from "./ExternalShareAction.vue?vue&type=script&lang=js"
export * from "./ExternalShareAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports